<template>
	<div>
		<div v-show="!cargaRegistros">
			<ol class="breadcrumb float-xl-right">
				<li class="breadcrumb-item active"><a href="javascript:;">Reportes</a></li>
			</ol>
			<h1 class="page-header">Módulo Reportes</h1>
			<div class="card  border-0 ">
				<div class="card-body">
					<div class="row">
						<!--<div class="col-lg-4">
							<local :valor_entrada="filtro.local" />
						</div>
						<div class="col-lg-4">
							<anios :valor_entrada="filtro.anio"/>
						</div>-->
						<div class="col-lg-5">
							<personal :valor_entrada="filtro.personal" v-model="filtro.personal"
								@evento="filtro.personal=$event" />
						</div>
						<div class="col-lg-2">
							<select  v-model="filtro.anio"  class="form-control font-weight-bold text-center">
								<option value="">Seleccione Año</option>
								<option v-for="r in aniosReporte" :key="r.anio" :value="r.anio"> {{r.anio}}</option>
							</select>
						</div>
						<div class="col-lg-2">
							 <button :disabled="filtro.anio==''" @click="consultar()" class="btn btn-indigo btn-block"> <i
									class="fa fa-search"></i> Consultar</button></div>
						<div class="col-lg-3">
							<button v-show="!carga_excel" @click="cargarExcel()" type="button"
								class="btn btn-danger btn-block btn-sm">
								<span v-show="!generar_excel"> <i class="fa fa-file-excel fa-lg "></i> Generar Excel SUTRAN</span> <span
									v-show="generar_excel"> <i class="fa fa-spinner fa-spin"></i> Generando excel espere por favor..</span>
							</button>
							<span v-show="carga_excel">
                <export-excel :footer="'REGISTROS: '+json_data.length"
                  title="::..SISTEMA DE AUTOMOTRIZ JURU..::"
                  class="btn btn-success btn-sm btn-block" :data="json_data" :fields="json_fields"
                  worksheet="HOJA 1" name="SUTRAN.xls">
                  <i class="fa fa-download"></i> DESCARGAR 
                </export-excel>
              </span>
						</div>
					</div>
					<hr>
					<div class="table-responsive">
						<table v-show="!proceso" class="table table-bordered table-hover">
							<thead>
								<tr>
									<th>AÑO</th>
									<th>MES</th>
									<th>GLP</th>
									<th>GNV</th>
									<th>TRIMOVIL</th>
									<th>MODIFICACIONES</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="r in dataReporte" :key="r.Id">
									<td>{{r.anio}}</td>
									<td>{{r.mes}}</td>
									<th class="text-center"><a :href="'#/glp/'+r.anio+'/'+r.Id+'/'+filtro.personal">
											{{r.GLP}}</a>
									</th>
									<th class="text-center"><a :href="'#/gnv/'+r.anio+'/'+r.Id+'/'+filtro.personal">
											{{r.GNV}}</a></th>
									<th class="text-center"><a
											:href="'#/trimovil/'+r.anio+'/'+r.Id+'/'+filtro.personal">
											{{r.TRIMOVIL}}</a></th>
									<th class="text-center"><a
											:href="'#/modificaciones/'+r.anio+'/'+r.Id+'/'+filtro.personal">
											{{r.MODIFICACIONES}}</a></th>
								</tr>
							</tbody>

						</table>
					</div>

					<procesando class="mt-4" v-show="proceso" :tipo="1" :texto="'Consultando..'" />
				</div>

			</div>
		</div>
		<procesando class="mt-4" v-show="cargaRegistros" :tipo="3" :texto="'Cargando..'" />
	</div>

</template>
<script>
import Vue from "vue";
	import procesando from '../components/compartidos/Procesando'
	import local from '../components/compartidos/SelectLocales.vue'
	import anios from '../components/compartidos/SelectAnios.vue'
	import personal from '../components/compartidos/SelectPersonal.vue'
	import axios from 'axios'
	import excel from "vue-excel-export";
	Vue.use(excel);
	export default {
		name: "PageReportes",
		components: {
			procesando,
			local,
			anios,
			personal
		},

		data() {
			return {
				aniosReporte:[],
				carga_excel:false,
				generar_excel:false,
				json_data:[],
				cargaRegistros: true,
				filtro: {
					local: "",
					personal: "Todo",
					anio: ""
				},
				dataReporte: [],
				proceso: false,
				nuevo: true,
				json_fields: {
          			Id: "Id",
          			TIPO: "tipo",
          			"NOMBRE MES": "nombre_mes",
          			MES: "mes",
          			DIA: "dia",
          			HORA: "hora",
          			MINUTOS: "minutos",
          			"ENTIDAD CERTIFICADORA": "entidad_certificadora",
          			"PLACA RODAJE": "placa_rodaje",
          			"FECHA DE EMISION": "fecha_emision",
          			"HORA EMISION": "hora_emision",
          			"CERTIFICADOR": "certificador",
          			"OPERACION": "operacion",
          			"EMPRESA": "nombre_empresa",
        		},
			}
		},
		created() {
			setTimeout(() => {
				this.cargaRegistros = false;
			}, 100);
			this.cargarAniosReporte();
		},
		methods: {
			consultar() {
				this.proceso = true;
				axios.post(this.URL_BASE() + "personas/reporte/", this.filtro).then(respuesta => {
					if (respuesta.data.msg == 'exito') {
						this.dataReporte = respuesta.data.data;
					}
					this.proceso = false;
				}).catch(function (error) {
					console.log("er store" + error);
					this.proceso = false;
				});
			},
			cargarExcel(){
				this.carga_excel=false;
				this.generar_excel = true;
				axios.post(this.URL_BASE() + "personas/reporteExcelSutran/").then(respuesta => {
					
					if (respuesta.data.msg == 'exito') {
					 this.json_data = respuesta.data.data;
					}
					this.carga_excel=true;
					this.generar_excel = false;
				}).catch(function (error) {
					console.log("er store" + error);
					this.generar_excel = false;
					this.carga_excel=false;
				});
			},
			cargarAniosReporte(){
				axios.post(this.URL_BASE() + "personas/aniosReporte/").then(respuesta => {
					if (respuesta.data.msg == 'exito') {
					 this.aniosReporte = respuesta.data.data;
					}
				}).catch(function (error) {
					console.log("er store" + error);
					
				});
			}
		}
	}
</script>